<template>
  <v-app>
    <div class="mainBackground">
      <v-main>
        <router-view />
      </v-main>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;1,500&display=swap");

.mainBackground {
  background-image: url("./assets/Background_with_map.png");
  background-color: #325380;
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.card-title {
  font-family: "Playfair Display", serif;
}

.home-title {
  font-size: 62pt;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 4px;
}

.home-title-small {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 4px;
}

.card-effect {
}

/* width */
::-webkit-scrollbar {
  width: 30px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #4E938C;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>